import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e85954fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card card-body schemeInfo" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-medium" }, "Транспорт:", -1))
const _hoisted_7 = { class: "fw-light mt-1" }
const _hoisted_8 = { class: "fw-light" }
const _hoisted_9 = { class: "fw-light" }
const _hoisted_10 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-medium" }, "Нагрузки на оси:", -1))
const _hoisted_12 = { class: "fw-light mt-1" }
const _hoisted_13 = { class: "fw-light" }
const _hoisted_14 = { class: "col-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-medium" }, "Загружено:", -1))
const _hoisted_16 = { class: "fw-light mt-2" }
const _hoisted_17 = { class: "col-5" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-medium" }, "Смещение ЦТ:", -1))
const _hoisted_19 = { class: "fw-light mt-1" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "fw-light" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxScrollView = _resolveComponent("DxScrollView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", null, "Схема погрузки №" + _toDisplayString(_ctx.model.number) + " в ТС \"" + _toDisplayString(_ctx.model.transport.name) + "\"", 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, "Заказ - " + _toDisplayString(_ctx.model.scheme.orderDescription), 1),
            _createElementVNode("div", _hoisted_8, "Количество - " + _toDisplayString(_ctx.model.scheme.count), 1),
            _createElementVNode("div", _hoisted_9, "Грузоподъемность - " + _toDisplayString(_ctx.numberFormat(_ctx.model.scheme.calcLoadCapacity)) + " кг", 1),
            (_ctx.model.transport.transportType === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, "Нагрузка на ось тягача - " + _toDisplayString(_ctx.numberFormat(_ctx.model.scheme.tractorLoad)) + " кг", 1),
                  _createElementVNode("div", _hoisted_13, "Нагрузка на ось прицепа - " + _toDisplayString(_ctx.numberFormat(_ctx.model.scheme.trailerLoad)) + " кг", 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", {
              class: "mt-1 cargoes",
              style: _normalizeStyle({ height: Math.min(_ctx.model.cargoes.length * 18, 100) + 'px' })
            }, [
              _createVNode(_component_DxScrollView, {
                width: "100%",
                height: "100%"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.cargoes, (item, ind) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: ind,
                      class: "fw-light"
                    }, _toDisplayString(item.name) + " - " + _toDisplayString(item.count) + " шт. ", 1))
                  }), 128))
                ]),
                _: 1
              })
            ], 4),
            _createElementVNode("div", _hoisted_16, "Вес груза - " + _toDisplayString(_ctx.numberFormat(_ctx.model.scheme.weight, 0)) + " кг (" + _toDisplayString(_ctx.model.transportLoadCapacityPercent) + "%)", 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createTextVNode(" Продольное - " + _toDisplayString(_ctx.numberFormat(Math.abs(_ctx.model.scheme.centerMassLongitudinalDisplacement))) + " мм " + _toDisplayString(_ctx.model.scheme.centerMassLongitudinalDisplacementDirection) + " ", 1),
              (_ctx.model.transport.transportType !== 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "(допуск " + _toDisplayString(_ctx.numberFormat(_ctx.model.scheme.permissibleLongitudinalDisplacement)) + " мм)", 1))
                : _createCommentVNode("", true),
              (_ctx.model.transport.transportType == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, ", " + _toDisplayString(_ctx.numberFormat(_ctx.model.scheme.cargoWeightDifferenceByHalfLength)) + " кг", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createTextVNode(" Поперечное - " + _toDisplayString(Math.abs(_ctx.model.scheme.centerMassTransverseDisplacement)) + " мм " + _toDisplayString(_ctx.model.scheme.centerMassTransverseDisplacementDirection) + " ", 1),
              (_ctx.model.transport.transportType !== 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "(допуск " + _toDisplayString(_ctx.numberFormat(_ctx.model.scheme.permissibleTransverseDisplacement)) + " мм)", 1))
                : _createCommentVNode("", true),
              (_ctx.model.transport.transportType == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, ", " + _toDisplayString(_ctx.numberFormat(_ctx.model.scheme.cargoWeightDifferenceByHalfWidth)) + " кг", 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}